export default __webpack_public_path__ + "static/media/productDevelopment.59b871c2.svg";